export const apiEndpoints = {
  CALL_TOKENS: 'call_tokens',
  CALL_LIST: 'calls',
};

export const APP_ID_SPACE = '__APP_ID__';
export const REGION_SPACE = '__REGION__';

export const BASE_URL = `https://${APP_ID_SPACE}.call-${REGION_SPACE}.cometchat.io/v3.0/`;
